import { SVGProps } from 'react';

export type HomeIconProps = SVGProps<SVGSVGElement> & {
  color?: string;
  fill?: string;
};

export const HomeIcon = ({ color = '#646464', fill = 'none', ...props }: HomeIconProps) => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.55735 8.78123L4.25 9.00594V9.38668V17V17.75H5H7.4H8.15V17V11.9011H13.85V17V17.75H14.6H17H17.75V17V9.38668V9.00594L17.4426 8.78123L11.4426 4.39456L11 4.07093L10.5574 4.39456L4.55735 8.78123Z"
      fill={fill}
      stroke={color}
      strokeWidth="1.5"
    />
  </svg>
);
